// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matchesCardContainer {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
  font-family: Lato;
  font-weight: 700;
  margin-bottom: 32px;
}

.matchesCardInfos {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.matchesScoreTeams {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 12px;
  background: #69c3c5;
  padding: 12px;
  z-index: 1;
}

.matchesScoreTeams .homeTeam,
.matchesScoreTeams .awayTeam {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.matchesScoreTeams .homeTeam .homeTeamName,
.matchesScoreTeams .awayTeam .awayTeamName {
  color: #fff;
  text-align: center;
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  /* 11px */
  text-transform: uppercase;
}

.matchesScoreTeams .homeTeam img,
.matchesScoreTeams .awayTeam img {
  width: 70px;
  height: 70px;
  border-radius: 100%;
}

.matchesScoreTeams .score {
  display: flex;
  gap: 4px;
  color: #fff;
  text-align: center;
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  /* 24px */
  text-transform: capitalize;
}

.matchesCardInfos .matchesStatus {
  position: absolute;
  width: 100%;
  text-align: center;
}

.matchesCardInfos{
  position: relative;
}
.topScorer{
  position: relative;
  width: 70%;
  background: #69c3c5;
  bottom: 16px;
  z-index: 0;
  padding: 4px;
  align-self: center;
  text-align: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Overview/Matches/MatchesCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV","sourcesContent":[".matchesCardContainer {\r\n  display: flex;\r\n  width: 100%;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  font-family: Lato;\r\n  font-weight: 700;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.matchesCardInfos {\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n}\r\n\r\n.matchesScoreTeams {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  gap: 12px;\r\n  align-self: stretch;\r\n  border-radius: 12px;\r\n  background: #69c3c5;\r\n  padding: 12px;\r\n  z-index: 1;\r\n}\r\n\r\n.matchesScoreTeams .homeTeam,\r\n.matchesScoreTeams .awayTeam {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.matchesScoreTeams .homeTeam .homeTeamName,\r\n.matchesScoreTeams .awayTeam .awayTeamName {\r\n  color: #fff;\r\n  text-align: center;\r\n  font-family: Lato;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%;\r\n  /* 11px */\r\n  text-transform: uppercase;\r\n}\r\n\r\n.matchesScoreTeams .homeTeam img,\r\n.matchesScoreTeams .awayTeam img {\r\n  width: 70px;\r\n  height: 70px;\r\n  border-radius: 100%;\r\n}\r\n\r\n.matchesScoreTeams .score {\r\n  display: flex;\r\n  gap: 4px;\r\n  color: #fff;\r\n  text-align: center;\r\n  font-family: Lato;\r\n  font-size: 24px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: 100%;\r\n  /* 24px */\r\n  text-transform: capitalize;\r\n}\r\n\r\n.matchesCardInfos .matchesStatus {\r\n  position: absolute;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.matchesCardInfos{\r\n  position: relative;\r\n}\r\n.topScorer{\r\n  position: relative;\r\n  width: 70%;\r\n  background: #69c3c5;\r\n  bottom: 16px;\r\n  z-index: 0;\r\n  padding: 4px;\r\n  align-self: center;\r\n  text-align: center;\r\n  border-bottom-left-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
